import React from 'react'
import { FastField } from 'formik'
import { CustomCheckboxWithoutInitialValue } from 'src/form'
import { Grid } from '@mui/material'

const interventions = [
  { name: 'PHQ9_GAD7', label: 'PHQ9 and GAD7 offered biweekly to assess for progress.' },
  { name: 'BIOFEEDBACK', label: 'Utilize heart rate device for biofeedback breathing practices.' },
  { name: 'IN_APP_CHAT', label: 'Engage in daily in-app chat (Mon–Fri) with a licensed therapist/psychologist.' },
  { name: 'CBT_MINDFULLNESS_ACT', label: 'CBT, Mindfulness, and ACT practices offered daily.' },
  {
    name: 'PSYCHOEDUCATION',
    label: 'Psychoeducation on cognitive and emotional health topics including sleep and nutrition.',
  },
  {
    name: 'TELEHEALTH_VIDEO',
    label:
      'Optional telehealth video sessions with licensed provider offered within 10 business days of last appointment.',
  },
  { name: 'PEER_SUPPORT', label: 'Access to an anonymous, confidential peer support space.' },
]

const Interventions = () => (
  <Grid item xs={12}>
    {interventions.map((intervention) => (
      <FastField
        key={`INTERVENTIONS_AND_PARTICIPANT_AGREEMENT.${intervention.name}`}
        fullWidth
        component={CustomCheckboxWithoutInitialValue}
        name={`INTERVENTIONS_AND_PARTICIPANT_AGREEMENT.${intervention.name}`}
        disabled
        label={intervention.label}
      />
    ))}
  </Grid>
)

export default Interventions
